module.exports = __webpack_public_path__ + "static/media/chris_bryson.cb03894a.jpg";